<template>
  <section>
    <h2 class="headline">Последние расчеты</h2>
    <v-container grid-list-xl>
      <v-row class="scroll_el_mobile last_calcs" no-gutters>
        <v-col cols="12" md="4" class="pa-1" v-for="calc in last_calcs" :key="calc.id" >
          <Calc :calc="calc" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>

import { mapState } from 'vuex';

import Calc from "../../components/landing/Calc.vue";

export default {
  name: "LastCalcs",
  components: {
    Calc
  },
  computed: mapState({
    last_calcs: (state) => state.LandingM.last_calcs,
  }),
};
</script>
